import { ColourMetrics } from "../../../../pages/inSeasonReviewPage/hooks/useFetchColours";
import { ReviewDataResponse } from "../../../../pages/inSeasonReviewPage/hooks/useFetchReviewData";

/**
 * For selected rows in In-Season Review table,
 * convert the ReviewDataResponse to ColourMetrics
 * suitable for the ColourChart.
 */
export function reviewDataToColourMetrics(
  rows: ReviewDataResponse
): ColourMetrics[] {
  const rowsWithColors = rows.filter(
    (row) => !!row.style_colour_hex_code && !!row.style_main_colour
  );

  const sums = rowsWithColors.reduce(
    (acc, row) => {
      if (!row.style_colour_hex_code || !row.style_main_colour) {
        return acc;
      }

      const current = acc[row.style_colour_hex_code] || {
        style_colour_hex_code: row.style_colour_hex_code,
        parent: row.style_main_colour,
        nis3_sum: 0,
        time_purchase_sum: 0
      };

      return {
        ...acc,
        [row.style_colour_hex_code]: {
          ...current,
          nis3_sum: current.nis3_sum + (row.nis3 ?? 0),
          time_purchase_sum:
            current.time_purchase_sum + (row.time_purchase ?? 0)
        }
      };
    },
    {} as Record<string, ColourMetrics>
  );

  return Object.values(sums);
}
